import React from 'react';
import PropTypes from 'prop-types';

const headerIconPropTypes = {
  theme: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  iconSize: PropTypes.number,
};

const RightHeaderIcon = ({ theme, disabled, iconSize }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 45 45"
  >
    <path
      fill="none"
      fillRule="nonzero"
      stroke={
        disabled
          ? theme.colors.common.disabled
          : theme.colors.common.peacockBlue
      }
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={iconSize}
      d="M16 11l13 11.5L16 34"
    />
  </svg>
);

const LeftHeaderIcon = ({ theme, disabled, iconSize }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 45 45"
  >
    <path
      fill="none"
      fillRule="nonzero"
      stroke={
        disabled
          ? theme.colors.common.disabled
          : theme.colors.common.peacockBlue
      }
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={iconSize}
      d="M29 11L16 22.5 29 34"
    />
  </svg>
);

RightHeaderIcon.propTypes = headerIconPropTypes;
LeftHeaderIcon.propTypes = headerIconPropTypes;

const MonthButtonContent = {
  leftButtonContent: LeftHeaderIcon,
  rightButtonContent: RightHeaderIcon,
};

export default MonthButtonContent;
